import { SubmitButton } from '@/v5/components/atoms/Button/SubmitButton';
import { MicrosoftSsoButton } from '@/v5/components/atoms/Button/MicrosoftSsoButton';
import { SsoDivider } from '@/v5/components/atoms/Divider/SsoDivider';

function LoginButtonGroup({ isSubmitting, isChecked, setShowError }) {
    return (
        <>
            <SubmitButton
                style={{
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
                    fontSize: '15px',
                    fontWeight: '600',
                }}
                isSubmitting={isSubmitting}>
                Sign in
            </SubmitButton>

            <SsoDivider />

            <MicrosoftSsoButton
                isChecked={isChecked}
                setShowError={setShowError}
            />
        </>
    );
}

export { LoginButtonGroup };
